<template>
  <div class="p-3 border rounded bg-white">
      <div class="mb-3">
        <h5><strong>Vizualizare: Factură Proformă</strong></h5>
        <div class="row">
          <div class="col-md-9">
            <table class="table table-bordered table-sm mb-3 bg-light">
              <thead>
                <tr class="table-success text-center">
                  <th>Client</th>
                  <th>Serie și nr. document</th>
                  <th>Data emiterii</th>
                  <th>Termen de plata</th>
                  <th>Sold</th>
                  <th>Stare</th>
                </tr>
              </thead>
              <tbody>
                <tr class="text-center">
                  <td class="text-start">{{factura.c_denumire}}</td>
                  <td>{{factura.sd_serie}} {{factura.nr_doc}}</td>
                  <td>{{ this.formatDate(factura.data_doc) || '/' }}</td>
                  <td>{{ this.formatDate(factura.data_scadenta) || '/' }}</td>
                  <td>{{ formatCurrency(factura.isf_sold) || '0.00'}}</td>
                  <td>
                    <span v-if="Number(factura.facturare) === 1" class="badge bg-success">Transformată în factură</span>
                    <span v-else class="badge bg-secondary">Proformă</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <table class="table table-bordered table-sm mb-3 bg-light">
        <thead>
          <tr class="table-success text-center">
            <th></th>
            <th>Tip</th>
            <th>Denumire articol / serviciu</th>
            <th>UM</th>
            <th>TVA %</th>
            <th>Cantitate</th>
            <th>Pret unitar</th>
            <th>Valoare</th>
            <th>TVA</th>
            <th>Total</th>
            <th>Cont credit</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center" v-for="(prod, index) in produse" :key="index">
            <td>{{ prod.pozitie || '' }}</td>
            <td>
              <b>{{ prod.tp_abreviere_tip_produs }}</b> <small class="text-muted">({{ prod.tp_text }})</small>
            </td>
            <td class="text-start">{{ prod.denumire || '' }}</td>
            <td>{{ prod.unitate_masura || '' }}</td>
            <td>{{ prod.cota_tva || '' }}</td>
            <td>{{ prod.cantitate || '' }}</td>
            <td>{{ formatCurrency(prod.pret_unitar) || '0.00'}}</td>
            <td>{{ formatCurrency(prod.valoare) || '0.00'}}</td>
            <td>{{ formatCurrency(prod.tva) || '0.00'}}</td>
            <td>{{ formatCurrency(prod.total) || '0.00'}}</td>
            <td>{{ prod.cont_credit || '' }}</td>
          </tr>
        </tbody>
      </table>
      <div class="d-flex justify-content-between align-items-start w-100">
        <table class="table table-bordered table-sm mb-3 bg-light w-75">
          <thead>
            <tr class="table-success text-center">
              <th style="width: 75%">Informatii suplimentare</th>
              <th style="width: 25%">Descarcarea de gestiune</th>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td class="text-start">
                
              </td>
              <td> 
                <div class="cls_DOCw_tabeliesiri3_row_0_col_1_ck_cant_g_F">
                    <i class="fa fa-exclamation-circle fa-lg" aria-hidden="true" style="color: #a94442;"></i>
                    &nbsp;&nbsp;<span style="color: #a94442;">
                        <strong>Fara descarcarea de gestiune.</strong>
                    </span> 
                    Livrarea produselor si descarcarea gestiunii se fac pe baza Avizului de Insotire a Marfurilor</div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex flex-column justify-content-center align-items-end me-4" style="min-width: 300px;">
          <div style="font-size: 1.2rem;"><strong>Total fara TVA:</strong> {{ formatCurrency(factura.iesiri_date_valoare) || '0.00'}}</div>
          <div style="font-size: 1.2rem;"><strong>Total TVA:</strong> {{ formatCurrency(factura.iesiri_date_tva) || '0.00'}} </div>
          <hr class="w-100 my-2"/>
          <div style="font-size: 1.5rem; font-weight: bold;"><strong>Total:</strong> {{ formatCurrency(factura.iesiri_date_total) || '0.00'}}</div>
        </div>
      </div>
      <!-- Inserted Delegat Table Here -->
      <table class="table table-bordered table-sm mb-3 bg-light w-75">
        <thead>
          <tr class="table-success text-center">
            <th>Delegat</th>
            <th>CNP/Buletin delegat</th>
            <th>Auto</th>
            <th>Curs Valutar</th>
            <th>Intocmit de</th>
            <th>CNP</th>
          </tr>
        </thead>
        <tbody>
          <tr class="text-center">
            <td>{{factura.delegat || '-'}}</td>
            <td>{{factura.delegat_cnp || '-'}}</td>
            <td>{{factura.delegat_auto || '-'}}</td>
            <td>{{factura.curs || '-'}}</td>
            <td>{{factura.nume || '-'}}</td>
            <td>{{factura.cnp || '-'}}</td>
          </tr>
        </tbody>
      </table>
    </div>
</template>

<script>


export default {
  props: {
    factura: Object,
    produse: Array
  },
  data () {
        return {
            setari_select2: {
                theme: 'bootstrap-5',
                placeholder: "Selectează din listă",
                width: "100%",
            },
            unitati_masura: [],
        }
    },
    methods: {
        formatDate(date) {
          if (!date) return '/';
          return new Date(date).toLocaleDateString('ro-RO');
        },
        formatCurrency(value) {
          if(value) {
            var formatter = new Intl.NumberFormat('ro-RO', {
              style: 'currency',
              currency: 'Lei',
              currencyDisplay: 'symbol',
            });
            return formatter.format(value);
          }
        },
        incarcaUnitatiMasura(){
            axios.get('/api/facturare/utils/incarcaUnitatiMasura')
            .then((response) => {
                this.unitati_masura = response.data;
            });
        },
    },
    created(){

        //this.incarcaUnitatiMasura();
        
    },
};
</script>